<div class="HomeShowList">
    <div class="title">
        <div class="line"></div>
        <div class="txt">Series Channels</div>
    </div>

    <div class="homeShowListWrapper" appMySwipe (mySwipeLeft)="onSwipeLeft($event)" (mySwipeRight)="onSwipeRight($event)">
        <!-- <a class="showItem"  *ngFor="let item of data.showList" (click)=" navigateToTargetRoute(item.url)"  > -->
        <!-- (touchstart)="onTouchStart($event, item.url)" (touchend)="onTouchEnd($event, item.url)" -->
         <a class="showItem"  *ngFor="let item of data.showList" [routerLink]="item.url">
            <div class="imgHolder">
                <img [src]="item.thumb" alt="">
                <div class="border" *ngIf="!isMobile"></div>
            </div>
        </a>
    </div>
</div>